import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import Spacer from "../ui/spacer/Spacer";
import * as stylex from '@stylexjs/stylex';
export default function Feedback(props) {
  var _props$errors, _props$errors2, _props$success, _props$success2;
  var style = {};
  if (props.margins) {
    var _props$margins$top, _props$margins$bottom, _props$margins$left, _props$margins$right;
    style.marginTop = (_props$margins$top = props.margins.top) === null || _props$margins$top === void 0 ? void 0 : _props$margins$top.toString().concat('px');
    style.marginBottom = (_props$margins$bottom = props.margins.bottom) === null || _props$margins$bottom === void 0 ? void 0 : _props$margins$bottom.toString().concat('px');
    style.marginLeft = (_props$margins$left = props.margins.left) === null || _props$margins$left === void 0 ? void 0 : _props$margins$left.toString().concat('px');
    style.marginRight = (_props$margins$right = props.margins.right) === null || _props$margins$right === void 0 ? void 0 : _props$margins$right.toString().concat('px');
  }
  if (((_props$errors = props.errors) === null || _props$errors === void 0 ? void 0 : _props$errors.length) > 1) {
    style.listStyle = 'square';
    style.marginLeft = '15px';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.errors && props.errors.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ol", stylex.props(ui.list, ((_props$errors2 = props.errors) === null || _props$errors2 === void 0 ? void 0 : _props$errors2.length) > 1 && ui.many), props.errors.map(function (error, idx) {
    return /*#__PURE__*/React.createElement("li", _extends({
      key: "feedback-".concat(idx)
    }, {
      className: "Feedback__ui.item evqkw79p Feedback__ui.error ev17q8loj"
    }), error);
  })), /*#__PURE__*/React.createElement(Spacer, {
    mbottom: props.spacer
  })), ((_props$success = props.success) === null || _props$success === void 0 ? void 0 : _props$success.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ol", stylex.props(ui.list, ((_props$success2 = props.success) === null || _props$success2 === void 0 ? void 0 : _props$success2.length) > 1 && ui.many), props.success.map(function (success, idx) {
    return /*#__PURE__*/React.createElement("li", _extends({
      key: "feedback-success-".concat(idx)
    }, {
      className: "Feedback__ui.item evqkw79p Feedback__ui.success ev1vy04vk"
    }), success);
  })), /*#__PURE__*/React.createElement(Spacer, {
    mbottom: props.spacer
  })));
}
Feedback.propTypes = {
  errors: PropTypes.array,
  success: PropTypes.array,
  spacer: PropTypes.number
};
Feedback.defaultProps = {
  spacer: 10
};

// @ts-ignore
_inject(".evglst9c{list-style:square}", 2000);
_inject(".eve8uvvx{list-style:none}", 2000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".evqkw79p{font-size:var(--text-size)}", 3000);
_inject(".ev17q8loj{color:var(--text-error)}", 3000);
_inject(".ev1vy04vk{color:var(--text-success)}", 3000);
var ui = {
  many: {
    "Feedback__ui.many": "Feedback__ui.many",
    listStyle: "evglst9c",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    $$css: true
  },
  list: {
    "Feedback__ui.list": "Feedback__ui.list",
    listStyle: "eve8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    padding: "ev1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    margin: "ev1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  }
};